export default function () {
    return useSiteConfig().benevoltDomain;
}